import { ShieldOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Shown to a signed-in Firebase user whose account is neither a full admin
 * nor an approved Blog/Press contributor (role === 'none'). This should be
 * rare — the admin panel isn't meant for other account types — but a
 * redirect loop isn't a reasonable fallback, so this renders a dead end
 * with just a sign-out action instead of bouncing them anywhere.
 */
export function AccessDenied() {
  const { logout, user } = useAuth();

  return (
    <div className="min-h-screen bg-[#07070f] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="w-14 h-14 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto mb-5">
          <ShieldOff className="w-6 h-6 text-[#ef4444]" />
        </div>
        <h1 className="text-xl font-semibold text-[#f1f5f9]">Access denied</h1>
        <p className="text-sm text-[#94a3b8] mt-2">
          {user?.email ? <span className="text-[#f1f5f9]">{user.email}</span> : 'This account'} doesn&apos;t
          have admin or Blog/Press contributor access on OBAET. If you believe this is a mistake,
          contact an administrator.
        </p>
        <button
          onClick={logout}
          className="mt-6 px-4 py-2 text-sm rounded-xl bg-[#141420] border border-[#252535] text-[#94a3b8] hover:text-[#f1f5f9] hover:border-[#353548] transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
